import React from 'react';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material';

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isSubmitting?: boolean;
  mode?: 'submit' | 'resubmit';
};

const SubmitClaimConfirmDialog: React.FC<Props> = ({
  open,
  onClose,
  onConfirm,
  isSubmitting = false,
  mode = 'submit',
}) => {
  const isResubmit = mode === 'resubmit';

  return (
  <Dialog open={open} onClose={isSubmitting ? undefined : onClose} maxWidth="sm" fullWidth>
    <DialogContent sx={{ pt: 3 }}>
      <Typography variant="body1" sx={{ mb: 2 }}>
        {isResubmit
          ? 'Please confirm you have finished updating your damaged inventory items and any related documentation.'
          : 'To prevent delays in handling your claim, make sure you have submitted documentation (proof) supporting every loss you are claiming.'}
      </Typography>
      <Typography variant="body1">
        {isResubmit
          ? 'Are you sure you want to re-submit your claim for review?'
          : 'Are you sure you want to submit the claim?'}
      </Typography>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2 }}>
      <Button onClick={onClose} disabled={isSubmitting}>
        Cancel
      </Button>
      <Button variant="contained" onClick={onConfirm} disabled={isSubmitting} sx={{ backgroundColor: 'var(--primary-color)' }}>
        {isSubmitting ? (
          <CircularProgress size={22} />
        ) : isResubmit ? (
          'Re-submit claim'
        ) : (
          'Submit claim'
        )}
      </Button>
    </DialogActions>
  </Dialog>
  );
};

export default SubmitClaimConfirmDialog;
